/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useImmer } from "use-immer";
import { AppContext } from "../../../store/AppScopeProvider";
import { errorMessage, successMessage } from "../../../utils";
import moment from "moment";
import {
  createClinetAccountSettlement,
  getPurchasedData,
} from "../api";
import {
  getClientAccountDetailsById,
} from "../../Customers";


export const useClientAccountSettlement = ({ settlementId }) => {
  const { appState } = useContext(AppContext);
  const {
    globalData,
    currentTabs: { clientAccDetails: currentTab },
  } = appState;

  const navigate = useNavigate();

  const [state, setState] = useImmer({
    isLoading: false,
    isSaveButtonBusy: false,
    data: {
      amount: "",
      settlement_date: null,
      payment_type_id: "",
      select_type: 0,
      transactions: [],
    },
    purchasedData: [],
    filterData: [],
    purchaseAmount: 0,
    amount: 0,
    storeFilteredClientAccounts: [],
    isViewOpen: false,
    details: null
  });

  const HandleClientAccountDetails = async (settlementId) => {
    try {
      const res = await getClientAccountDetailsById(settlementId);
      if (res.success) {
        setState((draft) => {
          draft.data.amount = Number(res.data.due_amount).toFixed(2);
          draft.amount = Number(res.data.due_amount).toFixed(2);
          draft.details = res.data;
        });
      }
    } catch (err) {
      errorMessage(err.response.data.message);
      setState((draft) => {
        draft.isLoading = false;
      });
    }
  };

  const getPurchasedDataList = async (settlementId) => {
    try {
      const res = await getPurchasedData(settlementId);
      if (res.success) {
        setState((draft) => {
          draft.purchasedData = res.data;
        });
      }
    } catch (err) { }
  };

  useEffect(() => {
    if (settlementId) {
      HandleClientAccountDetails(settlementId);
      getPurchasedDataList(settlementId);
    }
  }, [settlementId]);

  const handleInputChange = (event) => {
    const name = event.target?.name;
    const value = event.target?.value;
    setState((draft) => {
      draft.data = {
        ...draft.data,
        [name]: value,
      };
    });
  };

  const onMakeSettlement = async (id) => {
    const data = {
      ...state.data,
      settlement_date: moment(state.data.settlement_date).format(
        "yyyy-MM-DD"
      ),
      amount:
        state.data.select_type === 0
          ? state.data.amount
          : state.purchaseAmount,
    };

    try {
      setState((draft) => {
        draft.isSaveButtonBusy = true;
      });
      const res = await createClinetAccountSettlement(id, data);
      if (res.success) {
        successMessage(res.message);
        setState((draft) => {
          draft.isSaveButtonBusy = false;
        });
        navigate(`/store-admin/client-account-v2/details/${id}`);
      } else {
        errorMessage(res.message);
        setState((draft) => {
          draft.isSaveButtonBusy = false;
        });
      }
    } catch (err) {
      errorMessage(err.response.data.message);
      setState((draft) => {
        draft.isSaveButtonBusy = false;
      });
    }
  };



  const onSwitchChange = (e) => {
    const value = e.target.checked === true ? 1 : 0;
    setState((draft) => {
      draft.data.select_type = value;
    });
  };

  const toggleViewModal = (type) => {
    setState((draft) => {
      draft.isViewOpen = type;
    });
  };

  const handleChecked = (id) => {
    return state.data.transactions.includes(id);
  };

  const handleAllChecked = () => {
    const isAll = state.purchasedData.map((i) => i.id);

    return (
      isAll.length > 0 &&
      isAll.every((val) => state.data.transactions.includes(val))
    );
  };

  const handleCheckindeterminate = () => {
    const isAll = state.purchasedData.map((i) => i.id);
    const commonIDs = state.data.transactions?.filter((val) =>
      isAll.includes(val)
    );
    const notAllIDs = isAll.every((val) =>
      state.data.transactions.includes(val)
    );
    return commonIDs.length > 0 && !notAllIDs;
  };

  const handleSelectedIds = (e, row) => {
    if (e.target.checked) {
      setState((draft) => {
        draft.data.transactions = [
          ...draft.data.transactions,
          row.original.id,
        ];
      });
      setState((draft) => {
        draft.filterData = [...draft.filterData, row.original];
      });
    } else {
      setState((draft) => {
        draft.data.transactions = [
          ...draft.data.transactions.filter(
            (v) => v !== row.original.id
          ),
        ];
      });
      setState((draft) => {
        draft.filterData = [
          ...draft.filterData.filter((v) => v.id !== row.original.id),
        ];
      });
    }
  };

  const handleAllSelectedIds = (e, row) => {
    const isAll = state.purchasedData.map((i) => i.id);
    const isAllData = state.purchasedData.map((i) => i);
    if (e.target.checked) {
      setState((draft) => {
        draft.data.transactions = isAll;
        draft.filterData = isAllData;
      });
    } else {
      setState((draft) => {
        draft.data.transactions = [];
        draft.filterData = [];
      });
    }
  };

  useEffect(() => {
    if (state.filterData) {
      const purchaseAmount = state.filterData.reduce(
        (a, v) => (a = a + v.balance),
        0
      );
      setState((draft) => {
        draft.purchaseAmount = purchaseAmount;
      });
    }
  }, [state.filterData]);

  return {
    state,
    globalData,
    handleInputChange,
    onMakeSettlement,
    onSwitchChange,
    handleChecked,
    toggleViewModal,
    handleCheckindeterminate,
    handleSelectedIds,
    handleAllSelectedIds,
    handleAllChecked,
  };
};
